import { AbstractUserStore } from '@coach-bot/data-access/shared/stores/abstract/abstract-user.store';
import { LocalStorageService } from '../services';

export class CoachBotUserStore extends AbstractUserStore {
  constructor(protected localStorageService: LocalStorageService) {
    super(localStorageService);
  }
}
